import useTheme from "@mui/material/styles/useTheme";
import { observer } from "mobx-react-lite";
import React from "react";
import Axis3DIcon from "../icon/toolbar/Axis3DIcon";
import IconButton3D from "./IconButton3D";
import { useStore } from "csi/state/hooks";

const ShowAxisHelper = observer(() => {
	const { palette } = useTheme();	
	const secondary = palette.NavListItemSelectedBG;
	const rootStore = useStore();
	const { threeDStore: { modelViewerStore, toggleAxis } } = rootStore;
	const { axisHelperVisible } = modelViewerStore;
  
	return (
		<IconButton3D
			onClick = {toggleAxis}
			res={axisHelperVisible ? "3DHideAxis" : "3DShowAxis"}
			sx={{
				backgroundColor : axisHelperVisible ? secondary : "transparent",
			}}   
		>
			<Axis3DIcon />
		</IconButton3D>
	);
});

export default ShowAxisHelper;